import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { graphql, compose } from 'react-apollo';
import { Form, Input, Button, message, DatePicker, Checkbox } from 'antd';

import MUTATION from '../graphql/mutations/storeCacManagementPersonMutation.graphql';
import STORE_QUERY from '../graphql/queries/getCustomerAssociateConcernsQuery.graphql';
import validationRegex from '../utils/validationRegex';

const FormItem = Form.Item;
const { TextArea } = Input;

const labelColXsSpan = 4;
const formItemLayout = {
  labelCol: {
    xs: { span: labelColXsSpan },
  },
  wrapperCol: {
    xs: { span: 6 },
  },
};

const submitBtnLayout = {
  wrapperCol: {
    xs: {
      offset: labelColXsSpan,
    },
  },
};

class AssociateConcernManagementPersonForm extends Component {
  state = {
    submittingForm: false,
  };

  handleSubmit = (event) => {
    this.setState({
      submittingForm: true,
    });
    event.preventDefault();
    this.props.form.validateFieldsAndScroll((err, { street_address, ...values }) => {
      const { customer_id, cac_id } = this.props;
      if (!err) {
        this.props.mutate({
          variables: { cac_id, ...values, street_address: street_address.replace(/\r?\n|\r/g, ' ') },
          update: (cache, { data: { newCacManagementPerson } }) => {
            const data = cache.readQuery({
              query: STORE_QUERY,
              variables: { customer_id },
            });
            data.associateConcerns = data.associateConcerns.map((ac) => {
              const entry = ac;
              if (entry.id === parseInt(cac_id, 10)) {
                if (!Array.isArray(entry.management_persons)) entry.management_persons = [];
                entry.management_persons.push(newCacManagementPerson);
              }
              return entry;
            });
            cache.writeQuery({ query: STORE_QUERY, variables: { customer_id }, data });
          },
        })
          .then(() => {
            this.setState({
              submittingForm: false,
            });
            this.props.form.resetFields();
            message.success('Success!');
          })
          .catch((mutateErr) => {
            console.log(mutateErr);
            this.setState({
              submittingForm: false,
            });
            message.error(mutateErr.message);
          });
      } else {
        console.log(err);
        this.setState({
          submittingForm: false,
        });
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Form onSubmit={this.handleSubmit}>
        <FormItem
          hasFeedback
          label="First Name"
          {...formItemLayout}
        >
          {
            getFieldDecorator(
              'first_name',
              {
                rules: [
                  {
                    required: true,
                    message: 'Field is required!',
                  },
                ],
              },
            )(<Input />)
          }
        </FormItem>
        <FormItem
          hasFeedback
          label="Middle Name"
          {...formItemLayout}
        >
          {
            getFieldDecorator(
              'middle_name',
              {
                rules: [
                  {
                    required: true,
                    message: 'Field is required!',
                  },
                ],
              },
            )(<Input />)
          }
        </FormItem>
        <FormItem
          hasFeedback
          label="Last Name"
          {...formItemLayout}
        >
          {
            getFieldDecorator(
              'last_name',
              {
                rules: [
                  {
                    required: true,
                    message: 'Field is required!',
                  },
                ],
              },
            )(<Input />)
          }
        </FormItem>
        <FormItem
          hasFeedback
          label="Father's First Name"
          {...formItemLayout}
        >
          {
            getFieldDecorator(
              'father_first_name',
              {
                rules: [
                  {
                    required: true,
                    message: 'Field is required!',
                  },
                ],
              },
            )(<Input />)
          }
        </FormItem>
        <FormItem
          hasFeedback
          label="Father's Middle Name"
          {...formItemLayout}
        >
          {
            getFieldDecorator(
              'father_middle_name',
              {
                rules: [
                  {
                    type: 'string',
                    message: 'Incorrect format!',
                  },
                ],
              },
            )(<Input />)
          }
        </FormItem>
        <FormItem
          hasFeedback
          label="Father's Last Name"
          {...formItemLayout}
        >
          {
            getFieldDecorator(
              'father_last_name',
              {
                rules: [
                  {
                    required: true,
                    message: 'Field is required!',
                  },
                ],
              },
            )(<Input />)
          }
        </FormItem>
        <FormItem
          hasFeedback
          label="Designation"
          {...formItemLayout}
        >
          {
            getFieldDecorator(
              'designation',
              {
                rules: [
                  {
                    type: 'string',
                    message: 'Incorrect value!',
                  },
                ],
              },
            )(<Input />)
          }
        </FormItem>
        <FormItem
          label="Date of birth"
          {...formItemLayout}
        >
          {
            getFieldDecorator(
              'dob',
              {
                rules: [
                  {
                    required: true,
                    message: 'Field is required!',
                  },
                ],
              },
            )(<DatePicker />)
          }
        </FormItem>
        <FormItem
          hasFeedback
          label="PAN no."
          {...formItemLayout}
        >
          {
            getFieldDecorator(
              'pan_no',
              {
                rules: [
                  {
                    required: true,
                    message: 'Field is required!',
                  },
                  {
                    pattern: validationRegex.pan_no,
                    message: 'Incorrect PAN!',
                  },
                ],
              },
            )(<Input />)
          }
        </FormItem>
        <FormItem
          hasFeedback
          label="Aadhaar no."
          {...formItemLayout}
        >
          {
            getFieldDecorator(
              'aadhaar_no',
              {
                rules: [
                  {
                    required: true,
                    message: 'Field is required!',
                  },
                  {
                    pattern: validationRegex.aadhaar_no,
                    message: 'Incorrect Aadhaar!',
                  },
                ],
              },
            )(<Input />)
          }
        </FormItem>
        <FormItem
          label="Street address"
          {...formItemLayout}
        >
          {
            getFieldDecorator(
              'street_address',
              {
                rules: [
                  {
                    required: true,
                    message: 'Field is required!',
                  },
                ],
              },
            )(<TextArea rows={4} />)
          }
        </FormItem>
        <FormItem
          hasFeedback
          label="City"
          {...formItemLayout}
        >
          {
            getFieldDecorator(
              'city',
              {
                rules: [
                  {
                    required: true,
                    message: 'Field is required!',
                  },
                ],
              },
            )(<Input />)
          }
        </FormItem>
        <FormItem
          hasFeedback
          label="State"
          {...formItemLayout}
        >
          {
            getFieldDecorator(
              'state',
              {
                rules: [
                  {
                    required: true,
                    message: 'Field is required!',
                  },
                ],
              },
            )(<Input />)
          }
        </FormItem>
        <FormItem
          hasFeedback
          label="Pincode"
          {...formItemLayout}
        >
          {
            getFieldDecorator(
              'pincode',
              {
                rules: [
                  {
                    required: true,
                    message: 'Field is required!',
                  },
                  {
                    pattern: validationRegex.pincode,
                    message: 'Pincode incorrect!',
                  },
                ],
              },
            )(<Input />)
          }
        </FormItem>
        <FormItem
          hasFeedback
          label="Networth"
          {...formItemLayout}
        >
          {
            getFieldDecorator(
              'networth',
              {
                rules: [
                  {
                    required: true,
                    message: 'Field is required!',
                  },
                  {
                    pattern: validationRegex.float,
                    message: 'Incorrect value!',
                  },
                ],
              },
            )(<Input />)
          }
        </FormItem>
        <FormItem
          hasFeedback
          label="DIN"
          {...formItemLayout}
        >
          {
            getFieldDecorator(
              'din',
              {
                rules: [
                  {
                    type: 'string',
                    message: 'Incorrect value!',
                  },
                ],
              },
            )(<Input />)
          }
        </FormItem>
        <FormItem
          hasFeedback
          label="DPIN"
          {...formItemLayout}
        >
          {
            getFieldDecorator(
              'dpin',
              {
                rules: [
                  {
                    type: 'string',
                    message: 'Incorrect value!',
                  },
                ],
              },
            )(<Input />)
          }
        </FormItem>
        <FormItem
          label="Is Guarantor?"
          {...formItemLayout}
        >
          {
            getFieldDecorator('is_guarantor', {
              initialValue: false,
              valuePropName: 'checked',
            })(<Checkbox>Select if he/she is a guarantor</Checkbox>)
          }
        </FormItem>
        <FormItem
          label="Is Shareholder?"
          {...formItemLayout}
        >
          {
            getFieldDecorator('is_shareholder', {
              initialValue: false,
              valuePropName: 'checked',
            })(<Checkbox>Select if he/she is a shareholder</Checkbox>)
          }
        </FormItem>
        <FormItem
          hasFeedback
          label="Share (%)"
          {...formItemLayout}
        >
          {
            getFieldDecorator(
              'percent_share',
              {
                rules: [
                  {
                    pattern: validationRegex.float,
                    message: 'Incorrect value!',
                  },
                ],
              },
            )(<Input />)
          }
        </FormItem>
        <FormItem {...submitBtnLayout}>
          <Button type="primary" htmlType="submit" loading={this.state.submittingForm}>Submit</Button>
        </FormItem>
      </Form>
    );
  }
}

AssociateConcernManagementPersonForm.propTypes = {
  mutate: PropTypes.func.isRequired,
  form: PropTypes.shape({
    getFieldDecorator: PropTypes.func,
    validateFieldsAndScroll: PropTypes.func,
    resetFields: PropTypes.func,
  }).isRequired,
  customer_id: PropTypes.string.isRequired,
  cac_id: PropTypes.string.isRequired,
};

export default compose(
  graphql(MUTATION),
  Form.create(),
)(AssociateConcernManagementPersonForm);



// WEBPACK FOOTER //
// ./src/forms/AssociateConcernManagementPersonForm.jsx